import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // 페이지 이동을 위한 훅
import './Intro.scss';
import Breadcrumb from '../../components/common/Breadcrumb';

const Intro = () => {
  const navigate = useNavigate();
  const location = useLocation(); // 현재 경로 정보를 가져옴

  // 경로 일치 여부를 확인하는 함수
  const isActive = (path) => (location.pathname === path ? 'active' : '');

  return (
    <div className="sub-page intro">
      <section className="sub-visual about">
        <div className="container">
          <span className="sub-title">COMPANY PROFILE</span>
          <h1>회사소개서</h1>
          <p>베스트트레이딩의 가치와 비전을 소개합니다.</p>
        </div>
      </section>

      <Breadcrumb />

      <nav className="category-nav">
        <div className="container">
          <div className="nav-inner">
            <button className={isActive('/about/greeting')} onClick={() => navigate('/about/greeting')}>
              인사말
            </button>
            <button className={isActive('/about/map')} onClick={() => navigate('/about/map')}>
              찾아오시는 길
            </button>
            <button className={isActive('/about/intro')} onClick={() => navigate('/about/intro')}>
              회사소개서
            </button>
          </div>
        </div>
      </nav>

      <div className="container content-wrap">
        <div className="preparing-box">
          <div className="icon-ani">
            <span className="icon">📄</span>
            <span className="gear">⚙️</span>
          </div>
          <h2>서비스 준비 중입니다</h2>
          <p className="main-desc">
            더욱 정확하고 상세한 기업 정보를 제공해 드리기 위해 <br />
            <strong>회사소개서 페이지를 업데이트</strong>하고 있습니다.
          </p>
          <div className="sub-desc">
            <p>빠른 시일 내에 새로운 모습으로 찾아뵙겠습니다.</p>
            <p>관련 문의사항은 대표번호 031-366-0666으로 연락 바랍니다.</p>
          </div>

          {/* 메인 페이지로 이동하도록 수정 */}
          <button className="btn-back" onClick={() => navigate('/')}>
            메인페이지로 이동
          </button>
        </div>
      </div>
    </div>
  );
};

export default Intro;
